"use client";

import { motion } from "framer-motion";

import { Container } from "@/app/(marketing)/_components/ui/container";

const fields = [
  "Psychology",
  "Behavioral economics",
  "Human-computer interaction",
  "Linguistics",
  "Political science",
  "Public health",
  "Economics",
  "Education",
  "Marketing science",
  "Sociology",
  "Cognitive science",
  "Survey methodology",
];

export default function AcademicResearchFields() {
  return (
    <section className="py-20">
      <Container>
        {/* Section header */}
        <div className="mb-12 flex flex-col items-center gap-8">
          <div className="bg-marketing-card-blue rounded-t-[10px] px-2.5 py-1.5">
            <p className="text-marketing-blue font-mono text-sm tracking-[-0.28px]">
              Use cases
            </p>
          </div>
          <h2 className="text-marketing-text dark:text-marketing-cream text-heading-32 md:text-heading-40 lg:text-heading-48 max-w-[700px] text-center text-balance">
            Research we support across every field
          </h2>
          <p className="text-marketing-text-muted max-w-[560px] text-center text-lg">
            If your work needs human insight, Terac can source the people. From
            broad population samples to the most specialized professionals.
          </p>
        </div>

        {/* Fields grid */}
        <div className="flex flex-wrap justify-center gap-3">
          {fields.map((field, index) => (
            <motion.div
              key={field}
              initial={{ opacity: 0, transform: "translateY(12px)" }}
              whileInView={{ opacity: 1, transform: "translateY(0px)" }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.04 }}
              className="border-marketing-border flex items-center gap-2 rounded-full border bg-white px-4 py-2"
            >
              <div className="bg-marketing-blue h-1.5 w-1.5 rounded-full" />
              <span className="text-marketing-text text-sm font-medium">
                {field}
              </span>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  );
}
